import { render, staticRenderFns } from "./MailServerTable.vue?vue&type=template&id=63ea0818"
import script from "./MailServerTable.vue?vue&type=script&lang=js"
export * from "./MailServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports